// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3MnHO","legacyBtn":"MutateMid_legacyBtn__3xFjl"};